import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { getCSSColorBg } from '~/utilities/getCSS';
import { NavContext } from '~/contexts/NavContext';

const divider = cva('w-[1px] mx-5 h-1/2', {
  variants: {
    color: getCSSColorBg(),
  },
});

export default component$((): JSX.Element => {
  const { theme } = useContext(NavContext);

  return (
    <div
      class={divider({
        color: theme.SocialLinksColor.value,
      })}
    />
  );
});
